import { render, staticRenderFns } from "./small-business.vue?vue&type=template&id=3c1cd233&scoped=true"
import script from "./small-business.vue?vue&type=script&lang=js"
export * from "./small-business.vue?vue&type=script&lang=js"
import style0 from "./small-business.vue?vue&type=style&index=0&id=3c1cd233&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1cd233",
  null
  
)

export default component.exports